import React from 'react';

interface ErrorBoundaryState {
  hasError: boolean;
  error?: Error;
}

interface ErrorBoundaryProps {
  children: React.ReactNode;
}

class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('Error caught by boundary:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          minHeight: '100vh',
          background: 'linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%)',
          padding: '20px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          fontFamily: 'Arial, sans-serif'
        }}>
          <div style={{
            background: 'white',
            padding: '40px',
            borderRadius: '20px',
            boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
            textAlign: 'center',
            maxWidth: '600px',
            width: '100%'
          }}>
            <div style={{
              width: '80px',
              height: '80px',
              background: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto 20px auto'
            }}>
              <span style={{
                color: 'white',
                fontSize: '24px',
                fontWeight: 'bold'
              }}>!</span>
            </div>
            
            <h1 style={{
              color: '#1f2937',
              fontSize: '28px',
              marginBottom: '10px',
              fontWeight: 'bold'
            }}>
              Er is een fout opgetreden
            </h1>
            
            <p style={{
              color: '#6b7280',
              fontSize: '16px',
              marginBottom: '20px'
            }}>
              De app heeft een onverwachte fout tegengekomen.
            </p>
            
            <div style={{
              background: '#fef2f2',
              border: '1px solid #fecaca',
              padding: '15px',
              borderRadius: '10px',
              marginBottom: '20px',
              textAlign: 'left'
            }}>
              <p style={{
                color: '#b91c1c',
                fontSize: '14px',
                fontWeight: 'bold',
                marginBottom: '5px'
              }}>
                Fout details:
              </p>
              <p style={{
                color: '#7f1d1d',
                fontSize: '12px',
                fontFamily: 'monospace',
                wordBreak: 'break-word'
              }}>
                {this.state.error?.message || 'Onbekende fout'}
              </p>
            </div>
            
            <button 
              onClick={() => window.location.reload()}
              style={{
                background: '#3b82f6',
                color: 'white',
                padding: '12px 24px',
                border: 'none',
                borderRadius: '8px',
                fontSize: '16px',
                fontWeight: 'bold',
                cursor: 'pointer',
                transition: 'all 0.2s'
              }}
              onMouseOver={(e) => e.target.style.background = '#2563eb'}
              onMouseOut={(e) => e.target.style.background = '#3b82f6'}
            >
              🔄 Herlaad App
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;